import '../../app.es6';
import angular from 'angular';
import moment from '../../../node_modules/moment/moment.js';

const COURSE_MEMBER_PATH = '/staff/course';
const SCHOOL_MEMBER_PATH = '/admin/member';
const VIDEO_BACKLOG_PATH = '/staff/video_backlog';

class MemberDetailController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $rootScope, $location, $timeout,
    commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$location = $location;
    this.$timeout = $timeout;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();

    if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
      this.$location.path('/member');
    }

    if (!this.$sessionStorage[this.Const.SSAPP_MEMBER_ID]) {
      this.$location.path('/course');
    }

    this.getMemberIdMessages();

    Page.setTitle(this.Const.TITLE.memberDetail);

    this.videoList = [];
    this.$rootScope.videoList = this.videoList;
    this.getMemberIdVideos();

    let oldLocation = this.$sessionStorage[this.Const.SSAPP_OLD_LOCATION];
    if (oldLocation === SCHOOL_MEMBER_PATH) {
      this.$sessionStorage[this.Const.SSAPP_BREAD_CRUMB_PATTERN] = 0;
    } else if (oldLocation === COURSE_MEMBER_PATH) {
      this.$sessionStorage[this.Const.SSAPP_BREAD_CRUMB_PATTERN] = 1;
    } else if (oldLocation === VIDEO_BACKLOG_PATH) {
      this.$sessionStorage[this.Const.SSAPP_BREAD_CRUMB_PATTERN] = 2;
    }

    MemberDetailController.$inject = [
      '$scope', '$sessionStorage', '$rootScope', '$location', '$timeout',
      'commonApiFactory', 'commonFactory', 'Const', 'Page'
    ];
  }

  getMemberIdMessages () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }

    let getMembersMemberIdMessagesParams = {
      memberId: this.$sessionStorage[this.Const.SSAPP_MEMBER_ID],
      type: 1
    };
    this.commonApiFactory.getMembersMemberIdMessages(getMembersMemberIdMessagesParams)
    .then((result) => {
      this.messageList = [];
      result.forEach((message) => {
        // 一時保存中のメッセージは表出対象から除外する
        if (!message['data']['isUnpublished']) {
          let messageObj = {
            message: message['data']['message'],
            displayYear: moment(message['createdAt']).format('YYYY'),
            displayMonth: moment(message['createdAt']).format('MM'),
            displayDate: moment(message['createdAt']).format('DD')
          };
          this.messageList.push(messageObj);
        }
      });
      // リストを反転し最初のメッセージ(現在のテーマ)を削除
      this.messageList.reverse();
      this.messageList.shift();
      this.$timeout(() => {
        this.commonFactory.overlayHidden();
      }, 2200);
      this.$scope.$apply();
    })
    .catch((error) => {
      console.error(error);
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  toMemberTop () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$location.path('/member');
  }

  getMemberIdVideos () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    let reqParams = {
      memberId: this.$sessionStorage[this.Const.SSAPP_MEMBER_ID],
      limit: '',
      beginDateTime: '',
      order: 'desc',
      url: ''
    };
    this.commonApiFactory.getMembersMemberIdVideos(reqParams)
      .then((videos) => {
        videos.forEach((video) => {
          if (video == null) { return; }
          // アップロード済みの動画のみ表示
          if (video.state & this.Const.VIDEO_STATE_FLAG.uploaded) {
            this.videoList.push(video);
          }
        });
        if (this.videoList.length === 0) {
          this.videoList.push({});
        }
        this.$scope.$apply();
      });
  }

  removeVideo (index) {
    this.videoList.splice(index, 1);
    if (this.videoList.length === 0) {
      this.videoList.push({});
    }
    this.$scope.$apply();
  }

  addVideoUploadForm () {
    this.videoList.push({});
  }
}

angular.module('myApp').controller('MemberDetailController', MemberDetailController);



// WEBPACK FOOTER //
// ./app/components/member-detail/member-detail-controller.es6